(function () {
	let GRID = "[data-bv-recommendations]"
	let BOUND = "bvRecommendationsBound"

	function fill(grid) {
		let url = grid.dataset.bvRecommendationsUrl
		if (!url) return

		fetch(url)
			.then(response => (response.ok ? response.text() : Promise.reject(response.status)))
			.then(markup => {
				let parsed = new DOMParser().parseFromString(markup, "text/html")
				let fresh = parsed.querySelector(GRID)
				if (!fresh || !fresh.children.length) return

				grid.innerHTML = fresh.innerHTML

				for (let cell of grid.children) {
					cell.removeAttribute("data-bv-reveal")
					cell.style.removeProperty("--bv-reveal-delay")
				}

				document.dispatchEvent(new CustomEvent("bv:recommendations:loaded", { detail: { grid: grid } }))
			})
			.catch(() => {})
	}

	function bind(scope) {
		for (let grid of scope.querySelectorAll(GRID)) {
			if (grid.dataset[BOUND]) continue
			grid.dataset[BOUND] = "true"
			if (!grid.children.length) fill(grid)
		}
	}

	function boot() {
		bind(document)
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", boot)
	} else {
		boot()
	}

	document.addEventListener("shopify:section:load", event => {
		bind(event.target)
	})
})()
